<template>
  <div class="login">
    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form">
      <h3 class="title">烟箱积温云管理平台</h3>
      <el-form-item prop="username">
        <el-input v-model.trim="loginForm.loginCode" type="text" placeholder="账号">
          <svg-icon slot="prefix" icon-class="user" class="el-input__icon input-icon" />
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input v-model.trim="loginForm.password" type="password" placeholder="密码">
          <svg-icon slot="prefix" icon-class="password" class="el-input__icon input-icon" />
        </el-input>
      </el-form-item>
      <el-form-item prop="code">
        <el-input v-model.trim="loginForm.code" auto-complete="off" placeholder="验证码，不区分大小写" style="width: 60%" @keyup.enter.native="handleLogin">
          <svg-icon slot="prefix" icon-class="password" class="el-input__icon input-icon" />
        </el-input>
        <div class="login-code" title="看不清就点一下" @click="refreshCode()">
          <div id="dvCode">验证码</div>
        </div>
      </el-form-item>
      <el-form-item style="width:100%;">
        <el-button :loading="loading" size="medium" type="primary" style="width:100%;" @click.native.prevent="handleLogin">
          <span v-if="!loading">登 录</span>
          <span v-else>登 录 中...</span>
        </el-button>
      </el-form-item>
    </el-form>
    <!--  底部  -->
    <div class="el-login-footer">
      <span>Copyright © 2018-2022 linying All Rights Reserved.</span>
    </div>
  </div>
</template>

<script>
import { createVerifyCode } from '@/api/user'
var md5 = require('md5')

export default {
  name: 'Login',
  components: {},
  data() {
    const validateLoginCode = (rule, value, callback) => {
      if (value.length < 1) {
        callback(new Error('用户名不能小于1位'))
      } else {
        callback()
      }
    }
    const validateCode = (rule, value, callback) => {
      if (value.length < 1) {
        callback(new Error('验证码不能小于4位'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码不能小于6位'))
      } else {
        callback()
      }
    }
    return {
      loginForm: {
        code: '',
        loginCode: '',
        password: ''
      },
      loginRules: {
        code: [{ required: true, trigger: 'blur', validator: validateCode }],
        loginCode: [{ required: true, trigger: 'blur', validator: validateLoginCode }],
        password: [
          { required: true, trigger: 'blur', validator: validatePassword }
        ]
      },
      capsTooltip: false,
      loading: true,
      loadingText: '拼命加载中...',
      showDialog: false,
      redirect: undefined,
      otherQuery: {},
      codeUrl: '',
      codeId: ''
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        const query = route.query
        if (query) {
          this.redirect = query.redirect
          this.otherQuery = this.getOtherQuery(query)
        }
      },
      immediate: true
    }
  },
  created() {
    this.loading = false
    this.refreshCode()
  },
  mounted() {
    if (this.loginForm.phone === '') {
      this.$refs.phone.focus()
    } else if (this.loginForm.verifyCode === '') {
      this.$refs.verifyCode.focus()
    }
  },
  destroyed() {
    // window.removeEventListener('storage', this.afterQRScan)
  },
  beforeRouteEnter(to, from, next) {
    next((_this) => {
    })
  },
  methods: {
    checkCapslock(e) {
      const { key } = e
      this.capsTooltip = key && key.length === 1 && key >= 'A' && key <= 'Z'
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true
          this.loadingText = '拼命登录中...'
          console.log('handleLogin', this.openid)
          this.$store
            .dispatch('user/login', {
              id: this.codeId,
              code: this.loginForm.code,
              loginCode: this.loginForm.loginCode,
              password: md5(this.loginForm.password)
            })
            .then(() => {
              this.$router.push({ path: '/' })
              //  this.$router.push({ path: this.redirect || "/", query: this.otherQuery, });
              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          console.log('错误提交')
          return false
        }
      })
    },
    refreshCode() {
      createVerifyCode().then((outJson) => {
        // console.log(outJson)
        const svg = outJson.data.data
        document.getElementById('dvCode').innerHTML = svg

        this.codeId = outJson.data.id
      })
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur]
        }
        return acc
      }, {})
    },
    // 获取url参数
    getUrlKey(name) {
      return (
        decodeURIComponent(
          (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
            location.href
          ) || [, ''])[1].replace(/\+/g, '%20')
        ) || null
      )
    }

  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-image: url("../../assets/images/bg2.png");
  background-size: cover;
}
.title {
  margin: 0px auto 30px auto;
  text-align: center;
  color: #707070;
}

.login-form {
  border-radius: 6px;
  background: #ffffff;
  width: 400px;
  padding: 25px 25px 5px 25px;
  .el-input {
    height: 38px;
    input {
      height: 38px;
    }
  }
  .input-icon {
    height: 39px;
    width: 14px;
    margin-left: 2px;
  }
}
.login-tip {
  font-size: 13px;
  text-align: center;
  color: #bfbfbf;
}
.login-code {
  width: 40%;
  height: 38px;
  float: right;
  img {
    cursor: pointer;
    vertical-align: middle;
  }
}
.el-login-footer {
  height: 40px;
  line-height: 40px;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  color: #fff;
  font-family: Arial;
  font-size: 12px;
  letter-spacing: 1px;
}
.login-code-img {
  height: 38px;
}
</style>
